<div [hidden]="!isLoading" class="spinner-wrapper">
    <div class="spinner">Loading...</div>
</div>
<router-outlet></router-outlet>